<div style="display:none;">
  <form class="edx-upload-form">
    <input type="file" #uploadFilePicker multiple name="datafile" (change)="fileInputChanged()" (click)="fileInputClick()"/>
  </form>
</div>

@if (dialogShown) {
  <edx-popup #formDialog [desc]="desc" [callback]="this" [kind]="dialogKind" [extrasShown]="dialogExtrasShown"
    [desc2]="desc2" [kind2]="kind2" [width]="dialogWidth" [title]="dialogTitle" [ok]="dialogOK" [extras]="dialogExtras" [extrasAlt]="dialogExtrasAlt"
    [thirdtitle]="dialogThirdBtn" [selections]="list" [createType]="dialogCreateType" [okDisabled]="!!(formWrapper.okDisabled || (rightWrapper?rightWrapper.okDisabled:false))" [disabled]="pickerShown"
    [fileList]="fileList" [filePaths]="filePaths" [dataFiles]="dataFiles" [trustees]="dialogTrustees" [fileFormInfo]="dialogFileFormInfo" [headerformOnRight]="dialogSecurityShown && hasRightHeader()" [hideOK]="isFormReadonly() || isProfilePreviewForm()">
    <div>
      <edx-form-wrapper #formWrapper [formDialog]="formDialog"
        [desc]="formDialog.desc"
        [inDialog]="true"
        [kind]="formDialog.kind"
        [selections]="formDialog.selections"
        [createType]="formDialog.createType"
        [applyAllChecked]="dialogApplyAllChecked"
        (applyAllChanged)="onApplyAllChanged($event)"
        (extrasShownByChild)="extrasShownByChild($event)"
        (securityShownByChild)="securityShownByChild($event)"
        [fileList]="formDialog.fileList"
        [filePaths]="formDialog.filePaths"
        [dataFiles]="formDialog.dataFiles"
        [formData]="dialogFormData"
        [emailHasAttachments]="dialogEmailHasAttachments"
        [trustees]="formDialog.trustees"
        [fileFormInfo]="formDialog.fileFormInfo"
        [ngClass]="{left: desc2}"
        [rightWrapper]="rightWrapper"
        [headerWrapper]="headerWrapper"
        [readOnly]="isFormReadonly()"
        (formDataChanged)="dialogFormDataChanged($event)"
        [tabIndex]="ui>=2?1:0">
      </edx-form-wrapper>
      @if (desc2) {
        <edx-form-wrapper #rightWrapper
          [desc]="formDialog.desc2"
          [inDialog]="true"
          [kind]="formDialog.kind2"
          [selections]="formDialog.selections"
          [readOnly]="true"
          [layout]="(kind2!=='profile_copy' && kind2!=='profile_copy_tree')?'column':null"
          class="right"
          [headerWrapper]="headerWrapper">
        </edx-form-wrapper>
      }
    </div>
    @if (hasRightHeader() && !isPhoneLook()) {
      <edx-form-wrapper #headerWrapper rightheader [formData]="dialogFormData" [desc]="formDialog.desc" [createType]="formDialog.createType" [inDialog]="true" [kind]="'__local_permissions_selector'" [layout]="'header'" [mainWrapper]="getMainWrapper()"></edx-form-wrapper>
    }
    @if (hasRightHeader() && isPhoneLook()) {
      <edx-form-wrapper #headerWrapper phoneheader [tabIndex]="1" [formData]="dialogFormData" [desc]="formDialog.desc" [createType]="formDialog.createType" [inDialog]="true" [kind]="'__local_permissions_selector'" [layout]="'header'" [mainWrapper]="getMainWrapper()"></edx-form-wrapper>
    }
  </edx-popup>
}

@if (pickerShown) {
  <edx-popup #pickerPopup [callback]="this" [kind]="pickerKind" [width]="pickerWidth" [desc]="pickerDesc" [title]="pickerTitle" [ok]="pickerOK" [okDisabled]="pickerOKDisabled()" [headerform]="pickerHasFilter" [headerformOnRight]="hasRightHeader()" [levelDropdownOnRight] = "hasLevelDropdown()">
    @if (pickerHasFilter && pickerDesc.type==='lookups') {
      <edx-search-filter #filter secondheader [desc]="pickerPopup.desc" [searchValue]="lookupInitalSearch" [list]="picker" [selValue]="pickerSelLevel" [tabIndex]="ui>=2?1:0"></edx-search-filter>
    }
    @if (ui>=2 && ((pickerDesc.type==='folders' && pickerDesc.id==='downloads') || (pickerDesc.type==='lookups' && pickerDesc.id!=='_GROUPS_ENABLED'))) {
      <edx-list-mobile #picker [desc]="pickerDesc" [lookupForm]="pickerForm" [lookupKey]="pickerKey" [leadingColums]="pickerLeadingColums" [viewKind]="(pickerDesc.type==='folders' && pickerDesc.id==='downloads')?2:0" [hasFootprint]="true" [parent]="this"></edx-list-mobile>
    }
    @if (ui<2 && pickerDesc.type==='lookups' && pickerDesc.id!=='_GROUPS_ENABLED') {
      <edx-list-table #picker [desc]="pickerDesc" [lookupForm]="pickerForm" [lookupKey]="pickerKey" [leadingColums]="pickerLeadingColums" [parent]="this"></edx-list-table>
    }
    @if (pickerDesc.type==='lookups' && pickerDesc.id==='_GROUPS_ENABLED') {
      <edx-user-groups-picker #picker [desc]="pickerPopup.desc" [filterForm]="filter" [disableList]="pickerDisableList" [tabIndex]="ui>=2?2:0"></edx-user-groups-picker>
    }
    @if (pickerHasFilter && pickerDesc.type!=='lookups') {
      <edx-search-filter secondheader [desc]="pickerPopup.desc" [searchValue]="lookupInitalSearch" [list]="picker" [globalSearch]="true"></edx-search-filter>
    }
    @if (pickerDesc.type!=='lookups' && !(pickerDesc.type==='folders' && pickerDesc.id==='downloads')) {
      <edx-list-folder-picker #picker [kind]="pickerPopup.kind" [desc]="pickerPopup.desc" [disableList]="pickerDisableList" [rights]="pickerRights" [filterDocuments]="pickerFilterDocuments" id="edx_list_picker" (dismissPicker)="popupOK()"></edx-list-folder-picker>
    }
    @if (hasRightHeader() && !isPhoneLook()) {
      <edx-form-wrapper rightheader [desc]="pickerPopup.desc" [inDialog]="true" [kind]="'__local_locations_chooser'" [layout]="'header'"></edx-form-wrapper>
    }
    @if (hasRightHeader() && isPhoneLook()) {
      <edx-form-wrapper phoneheader [desc]="pickerPopup.desc" [inDialog]="true" [kind]="'__local_locations_chooser'" [layout]="'header'"></edx-form-wrapper>
    }
    @if (hasLevelDropdown()) {
      <edx-select levelDropdown [id]="edx_flexfolder_level" [value]="pickerCurFlexfoldersLevel?.display" [items]="pickerFlexfoldersLevels" class="spaced edx-select" [ngClass]="{right:ui>=2}" (change)="flexfolderLevelChanged($event)" [tabIndex]="ui>=2?'2':'0'"></edx-select>
    }
  </edx-popup>
}

@if (pickerCreateContainerShown) {
  <edx-popup #pccFormDialog [desc]="pccDesc" [callback]="this" [kind]="pccDialogKind" [extrasShown]="pccDialogExtrasShown" [title]="pccDialogTitle" [ok]="pccDialogOK" [extras]="pccDialogExtras" [extrasAlt]="pccDialogExtrasAlt" [createType]="pccDialogCreateType" [okDisabled]="!!pccFormWrapper.okDisabled" [trustees]="pccDialogTrustees" [fileFormInfo]="pccDialogFileFormInfo" [headerformOnRight]="true">
    <div>
      <edx-form-wrapper #pccFormWrapper [formDialog]="pccFormDialog" [desc]="pccFormDialog.desc" [kind]="'profile'" [createType]="pccFormDialog.createType" [trustees]="pccFormDialog.trustees" [fileFormInfo]="pccFormDialog.fileFormInfo" [inDialog]="true" [hideChoosers]="pccFormDialog.createType !== 'folders'" [hideLocation]="true" [formData]="pccDialogFormData" [headerWrapper]="pccHeaderWrapper" (pccExtrasShownByChild)="pccExtrasShownByChild($event)"></edx-form-wrapper>
    </div>
    @if (!isPhoneLook()) {
      <edx-form-wrapper #pccHeaderWrapper rightheader [formData]="pccDialogFormData" [desc]="pccFormDialog.desc" [createType]="pccFormDialog.createType" [inDialog]="true" [kind]="'__local_permissions_selector'" [layout]="'header'" [mainWrapper]="pccFormWrapper"></edx-form-wrapper>
    }
    @if (isPhoneLook()) {
      <edx-form-wrapper #pccHeaderWrapper phoneheader [formData]="pccDialogFormData" [desc]="pccFormDialog.desc" [createType]="pccFormDialog.createType" [inDialog]="true" [kind]="'__local_permissions_selector'" [layout]="'header'" [mainWrapper]="pccFormWrapper"></edx-form-wrapper>
    }
  </edx-popup>
}

@if (extSecurityShown || pccExtShown) {
  <edx-popup
    #pccExtDialog
    [desc]="pccExtShown ? pccDesc : desc"
    [callback]="this"
    [kind]="pccExtShown ?  pccDialogFormKind : dialogKind"
    [width]="dialogWidth"
    [title]="pccExtShown ? pccDialogTitle : dialogTitle"
    [ok]="pccExtShown ? pccDialogOK : dialogOK"
    [selections]="list"
    [createType]="pccExtShown ? pccDialogCreateType : null"
    [okDisabled]="pccExtShown">
    @if (ui<2) {
      <list-security-external
        #externalSecurity
        [kind]="pccExtShown ? pccDialogCreateType : null"
        [desc]="externalSecurityDesc"
        [securityList]="pccExtShown ? pccDialogTrustees : null"
        [popup]="pccExtDialog"
        [inDialog]="true">
      </list-security-external>
    }
  </edx-popup>
}

@if (pickerGroupsCreateContainerShown) {
  <edx-popup #pickerPopupGroups [callback]="this" [kind]="'list_2'" [desc]="pickerGroupsDesc" [title]="pickerGroupsTitle" [okDisabled]="pickerGroupsOKDisabled()" [headerform]="true" [headerformOnRight]="hasRightHeader()">
    <edx-search-filter #filterGroups secondheader [desc]="pickerPopupGroups.desc" [list]="pickerGroups" [selValue]="pickerSelLevel"></edx-search-filter>
    <edx-user-groups-picker #pickerGroups [desc]="pickerPopupGroups.desc" [filterForm]="filterGroups"></edx-user-groups-picker>
  </edx-popup>
}
